import React from "react";

export default function TableModal({
  open,
  onClose,
  tableForm,
  setTableForm,
  onSave,
  editing,
}) {
  if (!open) return null;

  return (
    <div className="so-table-modal fixed inset-0 flex items-center justify-center z-50">

      {/* Scoped SwiftOrder theme — same tokens as the rest of the POS. */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

        .so-table-modal {
          --ink: #1c1a17;
          --paper: #fbf9f4;
          --paper-dim: #f2ede1;
          --chili: #e4572e;
          --chili-dark: #c43f1a;
          --stone: #6b6459;
          --stone-light: #a49c8d;
          --line: #ddd4c2;
          --font-display: 'Bebas Neue', 'Arial Narrow', sans-serif;
          --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;

          background: rgba(28, 26, 23, 0.55);
          font-family: var(--font-body);
        }

        .so-table-modal * {
          box-sizing: border-box;
        }

        .so-modal-card {
          background: #fffdf8;
          border: 1px solid var(--line);
          border-radius: 12px;
          box-shadow: 0 24px 50px -20px rgba(28, 26, 23, 0.45);
        }

        .so-modal-title {
          font-family: var(--font-display);
          font-size: 1.7rem;
          letter-spacing: 0.01em;
          color: var(--ink);
        }

        .so-modal-close {
          color: var(--stone);
          font-size: 1.2rem;
          line-height: 1;
          background: transparent;
          transition: color 0.15s ease;
        }

        .so-modal-close:hover {
          color: var(--chili);
        }

        .so-modal-label {
          font-size: 0.78rem;
          font-weight: 700;
          font-family: var(--font-mono, monospace);
          letter-spacing: 0.03em;
          color: var(--stone);
          display: block;
          margin-bottom: 8px;
        }

        .so-modal-input {
          width: 100%;
          border: 1px solid var(--line);
          border-radius: 8px;
          padding: 10px 14px;
          background: var(--paper);
          color: var(--ink);
          outline: none;
          font-size: 0.95rem;
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }

        .so-modal-input:focus {
          border-color: var(--chili);
          box-shadow: 0 0 0 3px rgba(228, 87, 46, 0.15);
        }

        .so-modal-btn-cancel {
          background: var(--paper-dim);
          color: var(--ink);
          transition: background 0.15s ease;
        }

        .so-modal-btn-cancel:hover {
          background: var(--line);
        }

        .so-modal-btn-save {
          background: var(--chili);
          color: var(--paper);
          box-shadow: 0 10px 22px -10px rgba(228, 87, 46, 0.55);
          transition: background 0.15s ease;
        }

        .so-modal-btn-save:hover {
          background: var(--chili-dark);
        }
      `}</style>

      <div className="so-modal-card w-full max-w-lg p-6">

        {/* Header */}

        <div className="flex justify-between items-center mb-6">

          <h2 className="so-modal-title">
            {editing ? "Edit Table" : "Add Table"}
          </h2>

          <button
            onClick={onClose}
            className="so-modal-close"
          >
            ✕
          </button>

        </div>

        {/* Table Name */}

        <div className="mb-4">

          <label className="so-modal-label">
            Table Name
          </label>

          <input
            type="text"
            placeholder="Example : Table 1"
            value={tableForm.tableName}
            onChange={(e) =>
              setTableForm({
                ...tableForm,
                tableName: e.target.value,
              })
            }
            className="so-modal-input"
          />

        </div>

        {/* Capacity */}

        <div className="mb-4">

          <label className="so-modal-label">
            Capacity
          </label>

          <input
            type="number"
            min="1"
            value={tableForm.capacity}
            onChange={(e) =>
              setTableForm({
                ...tableForm,
                capacity: Number(e.target.value),
              })
            }
            className="so-modal-input"
          />

        </div>

        {/* Notes */}

        <div className="mb-6">

          <label className="so-modal-label">
            Notes
          </label>

          <textarea
            rows="4"
            placeholder="Window side, VIP, Family Table..."
            value={tableForm.notes}
            onChange={(e) =>
              setTableForm({
                ...tableForm,
                notes: e.target.value,
              })
            }
            className="so-modal-input resize-none"
          />

        </div>

        {/* Footer */}

        <div className="flex justify-end gap-3">

          <button
            onClick={onClose}
            className="so-modal-btn-cancel px-5 py-2 rounded-lg"
          >
            Cancel
          </button>

          <button
            onClick={onSave}
            className="so-modal-btn-save px-5 py-2 rounded-lg"
          >
            {editing ? "Update Table" : "Save Table"}
          </button>

        </div>

      </div>

    </div>
  );
}











// import React from "react";

// export default function TableModal({
//   open,
//   onClose,
//   tableForm,
//   setTableForm,
//   onSave,
//   editing,
// }) {
//   if (!open) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

//       <div className="bg-white rounded-xl shadow-xl w-full max-w-lg p-6">

//         {/* Header */}

//         <div className="flex justify-between items-center mb-6">

//           <h2 className="text-2xl font-bold text-slate-800">
//             {editing ? "Edit Table" : "Add Table"}
//           </h2>

//           <button
//             onClick={onClose}
//             className="text-slate-500 hover:text-red-600 text-xl"
//           >
//             ✕
//           </button>

//         </div>

//         {/* Table Name */}

//         <div className="mb-4">

//           <label className="block text-sm font-medium mb-2">
//             Table Name
//           </label>

//           <input
//             type="text"
//             placeholder="Example : Table 1"
//             value={tableForm.tableName}
//             onChange={(e) =>
//               setTableForm({
//                 ...tableForm,
//                 tableName: e.target.value,
//               })
//             }
//             className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
//           />

//         </div>

//         {/* Capacity */}

//         <div className="mb-4">

//           <label className="block text-sm font-medium mb-2">
//             Capacity
//           </label>

//           <input
//             type="number"
//             min="1"
//             value={tableForm.capacity}
//             onChange={(e) =>
//               setTableForm({
//                 ...tableForm,
//                 capacity: Number(e.target.value),
//               })
//             }
//             className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
//           />

//         </div>

//         {/* Notes */}

//         <div className="mb-6">

//           <label className="block text-sm font-medium mb-2">
//             Notes
//           </label>

//           <textarea
//             rows="4"
//             placeholder="Window side, VIP, Family Table..."
//             value={tableForm.notes}
//             onChange={(e) =>
//               setTableForm({
//                 ...tableForm,
//                 notes: e.target.value,
//               })
//             }
//             className="w-full border rounded-lg px-4 py-2 resize-none focus:ring-2 focus:ring-blue-500 outline-none"
//           />

//         </div>

//         {/* Footer */}

//         <div className="flex justify-end gap-3">

//           <button
//             onClick={onClose}
//             className="px-5 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
//           >
//             Cancel
//           </button>

//           <button
//             onClick={onSave}
//             className="px-5 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white"
//           >
//             {editing ? "Update Table" : "Save Table"}
//           </button>

//         </div>

//       </div>

//     </div>
//   );
// }
